module.exports = __webpack_public_path__ + "static/media/capacitacao.577ef056.png";